import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/ahaui/ahaui/apps/docs/src/layouts/ApiLayout.js";
import { graphql } from 'gatsby';
import ComponentApi from 'src/components/ComponentApi';
import CodeView from 'src/components/CodeView';
import separatorColor from 'src/examples/Separator/color';
import separatorLineType from 'src/examples/Separator/lineType';
export const query = graphql`
  query SeparatorQuery {
    metadata: componentMetadata(displayName: { eq: "Separator" }) {
      displayName
      ...ComponentApi_metadata
    }
  }
`;
export const _frontmatter = {};
const layoutProps = {
  query,
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "separator"
    }}>{`Separator`}</h1>
    <h2 {...{
      "id": "introduction"
    }}>{`Introduction`}</h2>
    <p>{`A divider that separates two different sets of content.`}</p>
    <img src={require('src/assets/structure/stb_separator-structure.jpg')} srcSet={`${require('src/assets/structure/stb_separator-structure@2x.jpg')} 2x`} className="u-maxWidthFull" alt="Separator" />
    <ol className="u-textGray u-marginTopTiny">
  <li>
    Label
  </li>
  <li>
    Left line
  </li>
  <li>Right line</li>
    </ol>
    <h2 {...{
      "id": "examples"
    }}>{`Examples`}</h2>
    <h3 {...{
      "id": "default"
    }}>{`Default`}</h3>
    <p>{`A solid Separator without a label.`}</p>
    <CodeView codeText={'<Separator  />'} mdxType="CodeView" />
    <h3 {...{
      "id": "with-label"
    }}>{`With label`}</h3>
    <p>{`A dashed Separator with label center-aligned.`}</p>
    <CodeView codeText={'<Separator label="Label" />'} mdxType="CodeView" />
    <h3 {...{
      "id": "colors"
    }}>{`Colors`}</h3>
    <CodeView codeText={separatorColor} mdxType="CodeView" />
    <h3 {...{
      "id": "line-styles"
    }}>{`Line styles`}</h3>
    <CodeView codeText={separatorLineType} mdxType="CodeView" />
    <h2 {...{
      "id": "design-reference"
    }}>{`Design Reference`}</h2>
    <p>{`N/A`}</p>
    <h2 {...{
      "id": "api"
    }}>{`API`}</h2>
    <ComponentApi metadata={props.data.metadata} mdxType="ComponentApi" />


    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      